<template>
	<PageLoading :is-loading="isLoading"></PageLoading>
	<SideComponent @scrollto="scroll"></SideComponent>
	<div class="container" ref="viewBox">		
		<div class="header-container">
			<HeaderVR />
			<!-- <div class="bigimg-container" v-if="banner.length>0">
				<Swiper :list="banner"/>
			</div> -->
		</div>
		<div id="content" class="content" ref="content">
			<!-- <Loading :is-loading="isListLoading"></Loading> -->
			<!-- <LivePlayer
			    videoUrl="https://volc-stream.kksmg.com/live/dfws/index.m3u8?volcSecret=884e2a1f9ff9d0a512a1ab8d33cf2f68&volcTime=1705476144"
			    fluent
			    live
			  ></LivePlayer> -->
			<!-- <LivePlayerDemo msg="LivePlayer.js H5直播点播播放器演示" /> -->
			 <!-- <VideoPlayer :options="playerOptions" />  -->
		</div>
		
		<Footer/>
	</div>
	
</template>

<script>
	import live from './live_controller';
	export default live;
</script>

<style src="@/assets/css/live.css" scoped></style>
<!-- 这段全局css代码在related_news_detail.vue,subject_detail.vue,tail_detail.vue都有，而且相同。 -->
<style>
/*.ar-content .html-content p img{
	width:86%!important;
	object-fit: contain;
}
@media screen and (max-width: 767px) {
	.ar-content .html-content p img{
		width:100%!important;
		max-width:375px!important;
		height:auto!important;
	}
}*/
</style>

